import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { CheckCircle, Upload, Eye } from 'lucide-react';

interface DisplayUploadSuccessModalProps {
  isOpen: boolean;
  displayTitle: string;
  displayId: string;
  onUploadAnother: () => void;
  onViewDisplay: () => void;
}

const DisplayUploadSuccessModal: React.FC<DisplayUploadSuccessModalProps> = ({
  isOpen,
  displayTitle,
  displayId,
  onUploadAnother,
  onViewDisplay,
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={() => {}}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader className="text-center">
          <div className="mx-auto w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-4">
            <CheckCircle className="w-8 h-8 text-green-600" />
          </div>
          <DialogTitle className="text-xl font-semibold text-green-900">
            Display Created Successfully!
          </DialogTitle>
          <DialogDescription className="text-gray-600 dark:text-gray-400 mt-2">
            Your display <span className="font-semibold text-foreground">{displayTitle}</span> has been created
            and is now live on the marketplace.
          </DialogDescription>
        </DialogHeader>
        
        <div className="flex flex-col gap-3 mt-6">
          <Button 
            onClick={onViewDisplay}
            size="lg"
            className="w-full flex items-center justify-center gap-2"
          >
            <Eye className="w-4 h-4" />
            View Display Live
          </Button>
          
          <Button 
            onClick={onUploadAnother}
            variant="outline"
            size="lg"
            className="w-full flex items-center justify-center gap-2"
          >
            <Upload className="w-4 h-4" />
            Create Another Display
          </Button>
        </div>
        
        <p className="text-xs text-center text-muted-foreground mt-4">
          Your display is immediately available for visitors to discover.
        </p>
      </DialogContent>
    </Dialog>
  );
};

export default DisplayUploadSuccessModal;